import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import CloseButton from '@/components/close-button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { H4, ParagraphRegular } from '@/components/text'
import ChequeEnglish from './cheque-english.png'
import ChequeChinese from './cheque-chinese.png'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 24px 40px;
  max-height: 95vh;
`

const ScrollWrapper = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  text-align: center;
`

const ModalText = styled(ParagraphRegular)`
  margin: 24px 0 40px;
  text-align: center;
`

const ChequeImage = styled.img`
  width: 100%;
  margin-bottom: 20px;
`

const FindBankNumbersModal = () => {
  const { t, i18n } = useTranslation()
  const { close } = useModalize()

  const localImg = i18n.language === 'zh' ? ChequeChinese : ChequeEnglish
  const titleText = t('l.payment_settings.edit.find_financial_info.title', 'Find Your Account Info')

  return (
    <Wrapper>
      <CloseButton onClick={close} />
      <ScrollWrapper>
        <H4>{titleText}</H4>
        <ModalText>
          {t(
            'l.payment_settings.edit.find_financial_info_description.text',
            `If you don't have a cheque, you can find the same information on a Direct Deposit Form from your online banking.`
          )}
        </ModalText>
        <ChequeImage src={localImg} alt={titleText} />
      </ScrollWrapper>
    </Wrapper>
  )
}

export const show = createModal(FindBankNumbersModal)
